import { Mapper } from './base-mapper';
import type { GetErgonomicToolsResponseDTO, ErgonomicToolValue } from '@/core/dto/custom-report';
import type { EwaErgonomicTools } from '@/types/ErgonomicWorkAnalysis';

export class GetErgonomicToolsMapper extends Mapper<EwaErgonomicTools> {
	constructor(private readonly data: GetErgonomicToolsResponseDTO) {
		super();
	}

	toDomain(): EwaErgonomicTools {
		return Object.entries(this.data).reduce((acc, [key, value]) => {
			acc[key as keyof EwaErgonomicTools] = value as ErgonomicToolValue;
			return acc;
		}, {} as EwaErgonomicTools);
	}
}
